module.exports = __webpack_public_path__ + "static/media/clutch-award.dd99e5f6.png";